import { useQuery } from '@tanstack/react-query';
import type { ContentCalendar, CursorPage } from '@seo/types';
import { apiGet } from '@/lib/api';

export function useCalendars(projectId?: string, limit = 50) {
  const params = new URLSearchParams();
  if (projectId) params.set('project_id', projectId);
  params.set('limit', String(limit));
  return useQuery({
    queryKey: ['calendars', { projectId, limit }],
    queryFn: () => apiGet<CursorPage<ContentCalendar>>(`/v1/calendars?${params.toString()}`),
  });
}
